"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleFavorite = exports.Name = exports.MenuTypes = void 0;
let MenuTypes = exports.MenuTypes = /*#__PURE__*/function (MenuTypes) {
  MenuTypes["AboutMenu"] = "about-mega-menu";
  MenuTypes["AccountSideMenu"] = "account-side-menu";
  MenuTypes["BurgerMenu"] = "burger-menu";
  MenuTypes["JoinMenu"] = "join-mega-menu";
  MenuTypes["Minibag"] = "mini-bag";
  MenuTypes["Notifications"] = "notifications";
  MenuTypes["SearchInput"] = "search-input";
  MenuTypes["SearchResults"] = "search-results";
  MenuTypes["VipOrder"] = "vip-order";
  MenuTypes["BeautyTipsMenu"] = "beauty-tips-menu";
  MenuTypes["InspirationMenu"] = "inspiration-menu";
  return MenuTypes;
}({});
const Name = exports.Name = 'toggle-menu-flyout';
const ToggleFavorite = exports.ToggleFavorite = Name;
//# sourceMappingURL=index.js.map